<template>
    <div id="simNotice">
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="手机号：">
                <el-input v-model.trim="searchForm.takePhone"  @keyup.enter.native="getNoticeList($event)" clearable></el-input>
            </el-form-item>
         <el-form-item label="ICCID：">
                <el-input v-model.trim="searchForm.oldIccid"  @keyup.enter.native="getNoticeList($event)" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getNoticeList($event)">搜索查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="old_iccid" label="ICCID"></el-table-column>
            <el-table-column prop="take_phone" label="手机号" ></el-table-column>
            <el-table-column prop="take_nickname" label="收货人姓名"></el-table-column>
               <el-table-column prop="take_address" label="收货人市区" ></el-table-column>
             <el-table-column prop="takeAddressInfo" label="收货人详细地址" ></el-table-column>
            <el-table-column prop="createTime" label="时间"></el-table-column>
            <el-table-column label="操作" width="120">
                <template v-slot="scope">
                    <el-button type="text" @click="showEditDialog(scope.row)">修 改</el-button>
                </template>    
            </el-table-column>
        </el-table>
        
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>    


        
        <el-dialog :append-to-body="true"  title="编辑" :visible.sync="editVisibale"  width="600px"  class="notifyDetail" :close-on-click-modal="false" @close="cancel()">
            <el-form ref="editForm" :model="editForm" label-width="140px">
                <el-form-item label="收货人姓名:" prop="takeNickname">
                    <el-input v-model="editForm.takeNickname"  ></el-input>
                </el-form-item>

                <el-form-item label="收货人电话：" prop="takePhone">
                    <el-input v-model="editForm.takePhone"  ></el-input>
                </el-form-item>
                 <el-form-item label="收货人市区" prop="takeAddress">
                    <el-input v-model="editForm.takeAddress"  ></el-input>
                </el-form-item>
                  <el-form-item label="地址详情" prop="takeAddressInfo">
                    <el-input v-model="editForm.takeAddressInfo"  ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel()">取 消</el-button>
                <el-button type="primary" @click="confirmHandler()">确 定</el-button>
            </div>
        </el-dialog>       

    </div>
</template>

<script>
import common from '@/utils/common.js'
export default {
    data(){
        return {  
            searchForm:{
                takePhone:null,
                oldIccid:null
            },
        linkStateOption:[
            {'id':3,'name':'跳转第三方链接'},
              {'id':4,'name':'跳转APP内部链接'}
        ],
         stateOption:[
            {'id':1,'name':'正常'},
              {'id':2,'name':'禁用'}
        ],
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },    

            detailVisible:false,
            detail:{
                title:null,
                content: null,
                createTime: null,
            },   

            branchSupplierOption: [],//运营商字典
            editVisibale: false,
            editForm:{
                id: null,
                title: null,
                content: null,
                linkUrl:null,
                state:null,
                supplierCodes: [],
                supplierNames: "",
                linkState:null,
                takeNickname:null,
                takePhone:null,
                takeAddress:null,
                takeAddressInfo:null
            },
            editRules: {
              
            },

        }
    },
    methods: {

        getNoticeList($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);        
            common.sysRequest('app/pc/adress/list', data, 'post').then(res=>{
                common.listCallback(this, res, 'tbpg');
            });
        },

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getNoticeList();
        },
        handleCurrentChange(val){            
            this.tbpg.currentPage = val;
            this.getNoticeList();
        },

        showDetail(data){
            this.detail = data;
            this.detailVisible = true;
        },

        showEditDialog(data){
            if(data){
                this.editForm.id=data.id;
                this.editForm.takeNickname=data.take_nickname;
                this.editForm.takePhone=data.take_phone;
                this.editForm.takeAddress=data.take_address;
                this.editForm.takeAddressInfo=data.takeAddressInfo;
            }else{
                this.editForm = {
                    id: null,
                    title: null,
                    content: null,
                    linkUrl: null,
                    supplierCodes: [],
                    supplierNames: "",
                };
            }
            this.editVisibale = true;
        },

        chooseAll(){
            let val = [];
            for(let i in this.branchSupplierOption){
                val.push(this.branchSupplierOption[i].id);
            }
            this.editForm.supplierCodes = val;
        },
        cancelChooseAll(){
            this.editForm.supplierCodes = [];
        },

        confirmHandler(){
            this.$refs.editForm.validate(valid => {
                if(valid) {
                    let d = this.editForm;
                    let path = "app/pc/update/adress";
                    if(d.id && d.id!=""){
                       path =  "app/pc/update/adress"
                    }
                    common.sysRequest(path, d, 'post').then(res => {
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.cancel();
                            this.getNoticeList();
                            
                        }else{
                           this.$message.error(res.data.message); 
                        }
                    })
                }
            });
        },

        cancel(){
            this.editForm = {
                id: null,
                title: null,
                content: null,
                linkUrl: null,
                supplierCodes: [],
                supplierNames: "",
            };
            this.editVisibale = false;
        },
    },
    created(){
        this.getNoticeList();
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');
    }
}
</script>

<style lang="less" scoped>
    .lineInDialog{
        label{
            width: 120px;
            font-weight: bold;
        }
    }
</style>

